export default function Layout({ children }: { children?: any }) {
  return (
    <>
      <div className="flex min-h-screen">
        <div className="bg-white flex-1 flex flex-col w-full lg:max-w-xl lg:px-12">
          <div className="flex flex-1 items-center justify-center">
            <div className="items-center justify-center flex flex-col w-full">
              <img
                src="./../../DF-Logo-Color.png"
                className="justify-center w-[245px]"
                alt="Dayton Freight Logo"
              />

              {children}
            </div>
          </div>

        </div>

        <div className="flex-1 flex flex-col justify-center hidden lg:block relative w-0">
          <img
            src="./../../bluetruck.jpg"
            className="absolute inset-0 h-full w-full object-cover bg-indigo-900"
            alt=""
          />
        </div>
      </div>
    </>
  );
}